/* eslint-disable */
import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { FaApple, FaAndroid } from 'react-icons/fa';

const PLATFORM_META = {
  ios: { Icon: FaApple, iconClassName: 'installAppQrPlatformIconIos' },
  play: { Icon: FaAndroid, iconClassName: 'installAppQrPlatformIconAndroid' },
  android: { Icon: FaAndroid, iconClassName: 'installAppQrPlatformIconAndroid' },
};

export function getInstallAppPlatformMeta(platform) {
  return PLATFORM_META[platform] || PLATFORM_META.android;
}

export default function InstallAppQrTile({ platform, url, title, subtitle, qrAlt, onQrClick }) {
  const [qrDataUrl, setQrDataUrl] = useState('');
  const { Icon, iconClassName } = PLATFORM_META[platform] || PLATFORM_META.android;

  useEffect(() => {
    let active = true;

    async function generateQr() {
      if (!url) {
        if (active) setQrDataUrl('');
        return;
      }

      try {
        const dataUrl = await QRCode.toDataURL(url, {
          margin: 1,
          width: 220,
          errorCorrectionLevel: 'M',
          color: {
            dark: '#241631',
            light: '#fff9ff',
          },
        });

        if (active) setQrDataUrl(dataUrl);
      } catch {
        if (active) setQrDataUrl('');
      }
    }

    generateQr();
    return () => {
      active = false;
    };
  }, [url]);

  return (
    <article className="installAppQrTile">
      <div className="installAppQrPlatformRow">
        <Icon className={`installAppQrPlatformIcon ${iconClassName}`} aria-hidden />
        <div className="installAppQrPlatformText">
          <h2 className="installAppQrPlatformTitle">{title}</h2>
          <p className="installAppQrPlatformSubtitle">{subtitle}</p>
        </div>
      </div>

      {qrDataUrl ? (
        <a
          href={url}
          className="installAppQrLink"
          target={platform === 'android' ? undefined : '_blank'}
          rel="noopener noreferrer"
          download={platform === 'android' ? 'km220.apk' : undefined}
          aria-label={qrAlt}
          onClick={event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
              return;
            }
            event.preventDefault();
            onQrClick?.({
              platform,
              url,
              qrDataUrl,
              title,
              subtitle,
              qrAlt,
            });
          }}
        >
          <div className="installAppQrFrame">
            <img src={qrDataUrl} alt="" className="installAppQrImage" />
          </div>
        </a>
      ) : (
        <div className="installAppQrPlaceholder" aria-hidden />
      )}
    </article>
  );
}
